<template>
    <div class="container">
        <h4 class="title is-4">Events</h4>
        <app-events-filters :preselected="filters" :onSubmit="handleSubmit"></app-events-filters>
        <app-events-log-list :data="events"></app-events-log-list>
    </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex';
  import EventsFilters from '../components/EventsFilters';
  import EventsLogList from '../components/EventsLogList';

  export default {
    name: "screen-events",
    components: {
      appEventsFilters: EventsFilters,
      appEventsLogList: EventsLogList
    },
    data() {
      return {
      };
    },
    computed: {
      ...mapGetters('events', ['filters', 'events'])
    },
    methods: {
      ...mapMutations('events', ['SET_FILTERS']),
      ...mapActions('events', ['fetchEvents']),
      handleSubmit(params) {
        this['SET_FILTERS'](params);
        this.fetchEvents(params);
      }
    }
  }
</script>

<style scoped>

</style>